import Swiper, { SwiperSlide } from '@/components/common/Swiper';
import PLACEHOLDER_LOGO from '@/assets/images/logo/weee-placeholder-logo.png';

export default function CarouselSkeleton() {
  return (
    <div className="w-full px-5 box-border pt-3">
      <div className="h-[140px] w-full rounded-400 box-border border border-solid border-[rgba(0,25,88,0.08)]">
        <Swiper className="w-full" spaceBetween={20} slidesPerView={1}>
          {new Array(3).fill(0).map((item, index) => {
            return (
              <SwiperSlide key={`banner-${index}`} className="h-[140px] w-full rounded-400">
                <div className="h-[140px] w-full rounded-400">
                  <div
                    className="h-[140px] w-full"
                    style={{
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      backgroundImage: `url(${PLACEHOLDER_LOGO})`,
                      backgroundSize: '105px 31.5px'
                    }}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
